import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./PropertyList.css";
import { hasAnyPermission } from "../../permissions";

const API_BASE = process.env.REACT_APP_API_BASE || "";
// EDIT OPTION HIDE FOR OTA EXECUTIVE ROLE STARTS HERE (Sales Executive
// gets the same roles as OTA Executive, so it's deliberately left out of
// EDIT_ALLOWED_ROLES here too, exactly like OTA Executive is)
const ROLES = {
  SUPER_ADMIN: "SUPER ADMIN",
  ADMIN: "ADMIN",
  OTA_MANAGER: "OTA MANAGER",
  OTA_EXECUTIVE: "OTA EXECUTIVE",
  SALES_EXECUTIVE: "SALES EXECUTIVE",
  ONBOARDING_MANAGER: "ONBOARDING MANAGER",
  ONBOARDING_EXECUTIVE: "ONBOARDING EXECUTIVE",
};

const EDIT_ALLOWED_ROLES = [
  ROLES.SUPER_ADMIN,
  ROLES.ADMIN,
  ROLES.OTA_MANAGER,
  ROLES.ONBOARDING_MANAGER,
  ROLES.ONBOARDING_EXECUTIVE,
];
// ENDS HERE

const PropertyDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const loggedInRole = localStorage.getItem("loggedInRole");
  const loggedInUser = localStorage.getItem("loggedInUser");
  const canEditProperty = EDIT_ALLOWED_ROLES.includes(loggedInRole) || hasAnyPermission(["read_write_properties_list"]);
  const queryParams = new URLSearchParams(location.search);
  const propertyIdFromUrl = queryParams.get("id");

  const [property, setProperty] = useState(null);
  const [editProperty, setEditProperty] = useState(null);
  const [loading, setLoading] = useState(true);

  const propertyId = propertyIdFromUrl;
  // EDIT MAY 15 2026 STARTS HERE
const [isEditing, setIsEditing] = useState(false);
const [saving, setSaving] = useState(false);
const [photoRefreshKey, setPhotoRefreshKey] = useState(Date.now());
  useEffect(() => {
  const fetchPropertyDetails = async () => {
    if (!propertyId) {
      alert("Property ID missing. Please reopen this property from the list.");
      navigate("/PropertiesList");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(`${API_BASE}/api/properties/${propertyId}`);

      setProperty(res.data);
      setEditProperty(res.data);
    } catch (err) {
      console.error(
        "Failed to fetch property details:",
        err.response?.data || err.message
      );

      alert(
        err.response?.data?.message ||
          "Failed to load property details. Please try again."
      );

      navigate("/PropertiesList");
    } finally {
      setLoading(false);
    }
  };

  fetchPropertyDetails();
}, [propertyId, navigate]);
  // ENDS HERE
  
  const [activeTab, setActiveTab] = useState("Property Details");

  // PHASE 2 EDITS START
    // === UPLOAD DOCS STATE ===
 const [docUploads, setDocUploads] = useState({
  gstCertificate: null,
  leaseAgreement: null,
  msmeDocument: null,
  utilityBill: null,
  aadhaarCard: null,
  panCard: null,
  otherDocument: null,
  letterHead: null,
  cancelledCheque: null,
  paymentQr: null,
});

const [uploadingDocs, setUploadingDocs] = useState(false);

const handleDocUpload = async () => {
  if (!canEditProperty) {
  alert("Access denied. You are not allowed to upload documents.");
  return;
}
  if (!propertyId) {
    alert("Property ID missing. Please reopen this property from the list.");
    return;
  }

  const formData = new FormData();
  let hasFile = false;
  formData.append("uploadedBy", loggedInUser || "Unknown");
  formData.append("uploadedByRole", loggedInRole || "");

  Object.entries(docUploads).forEach(([key, file]) => {
    if (file) {
      hasFile = true;
      formData.append(key, file); // gstCertificate, msmeDocument, etc.
    }
  });

  if (!hasFile) {
    alert("Please select at least one document to upload.");
    return;
  }

  try {
    setUploadingDocs(true);

    // 1) Upload docs to backend
    const uploadRes = await axios.post(
      `${API_BASE}/api/properties/${propertyId}/upload-docs`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    console.log("upload-docs response:", uploadRes.data);
    const refreshed = await axios.get(`${API_BASE}/api/properties/${propertyId}`);

setProperty(refreshed.data);
setEditProperty(refreshed.data);

    // 2) Immediately update the local property object
//    so the Documents / Payment tabs show new files
// setProperty((prev) => {
//   if (!prev) return prev;
//   const updated = { ...prev };

//   Object.entries(docUploads).forEach(([key, file]) => {
//     if (file) {
//       updated[key] = file.name;
//     }
//   });

//   return updated;
// });

// // ADD THIS BLOCK HERE
// setEditProperty((prev) => {
//   if (!prev) return prev;
//   const updated = { ...prev };

//   Object.entries(docUploads).forEach(([key, file]) => {
//     if (file) {
//       updated[key] = file.name;
//     }
//   });

//   return updated;
// });

// 3) Clear file inputs
setDocUploads({
  gstCertificate: null,
  leaseAgreement: null,
  msmeDocument: null,
  utilityBill: null,
  aadhaarCard: null,
  panCard: null,
  otherDocument: null,
  letterHead: null,
  cancelledCheque: null,
  paymentQr: null,
});

    alert("✅ Documents uploaded successfully!");
  } catch (err) {
    console.error(
      "upload-docs error:",
      err.response?.status,
      err.response?.data || err.message
    );
    alert("❌ Failed to upload documents. Please try again.");
  } finally {
    setUploadingDocs(false);
  }
};

  const compressImageFile = (file, maxWidth = 1400, quality = 0.72) => {
  return new Promise((resolve, reject) => {
    if (!file || !file.type?.startsWith("image/")) {
      resolve(file);
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Image compression failed."));
              return;
            }

            const compressedFile = new File(
              [blob],
              file.name.replace(/\.[^/.]+$/, "") + ".jpg",
              {
                type: "image/jpeg",
                lastModified: Date.now(),
              }
            );

            resolve(compressedFile);
          },
          "image/jpeg",
          quality
        );
      };

      img.onerror = () => reject(new Error("Invalid image file."));
      img.src = event.target.result;
    };

    reader.onerror = () => reject(new Error("Failed to read image file."));
    reader.readAsDataURL(file);
  });
};
  
// PAHSE 2 IMAGE DISPLAY STARTS HERE
const uploadRoomPhotos = async (roomIndex, files) => {
  if (!canEditProperty) {
    alert("Access denied. You are not allowed to upload room photos.");
    return;
  }

  if (!propertyId) {
    alert("Property ID missing. Please reopen this property from the list.");
    return;
  }

  const selectedFiles = Array.from(files || []);

  if (!selectedFiles.length) return;

  const imageFiles = selectedFiles.filter((file) =>
    file.type?.startsWith("image/")
  );

  if (!imageFiles.length) {
    alert("Please select valid image files only.");
    return;
  }

  if (imageFiles.length > 4) {
    alert("You can upload maximum 4 room photos at once.");
    return;
  }

  const compressedFiles = await Promise.all(
    imageFiles.map((file) => compressImageFile(file))
  );

  const oversizedFile = compressedFiles.find(
    (file) => file.size > 2 * 1024 * 1024
  );

  if (oversizedFile) {
    alert(
      `Image '${oversizedFile.name}' is still too large after compression. Please use an image below 2MB.`
    );
    return;
  }

  const formData = new FormData();

  formData.append("uploadedBy", loggedInUser || "Unknown");
  formData.append("uploadedByRole", loggedInRole || "");

  compressedFiles.forEach((file) => {
    formData.append("roomPhotos", file);
  });

  const uploadRes = await axios.post(
    `${API_BASE}/api/properties/${propertyId}/room-photo/${roomIndex}`,
    formData
  );

  console.log("room-photo upload response:", uploadRes.data);

  const refreshed = await axios.get(`${API_BASE}/api/properties/${propertyId}`);

  setPhotoRefreshKey(Date.now());
  setProperty(refreshed.data);
  setEditProperty(refreshed.data);
};
  // ENDS HERE



  // PHASE 2 EDITS END

const buildDocumentURL = (fieldKey, storedValue) => {
  if (!storedValue || !propertyId) return null;

  if (
    typeof storedValue === "string" &&
    (storedValue.startsWith("http://") || storedValue.startsWith("https://"))
  ) {
    return storedValue;
  }

  return `${API_BASE}/api/properties/${propertyId}/document/${fieldKey}`;
};



 const buildRoomPhotoURL = (photo) => {
  if (!photo) return null;

  // New local file preview
  if (photo instanceof File) {
    return URL.createObjectURL(photo);
  }

  // Full backend URL
  if (
    typeof photo === "string" &&
    (photo.startsWith("http://") || photo.startsWith("https://"))
  ) {
    return `${photo}${photo.includes("?") ? "&" : "?"}v=${photoRefreshKey}`;
  }

  // Relative API or uploads path
  if (typeof photo === "string" && photo.startsWith("/")) {
    return `${photo}${photo.includes("?") ? "&" : "?"}v=${photoRefreshKey}`;
  }

  // Old filename string
  if (typeof photo === "string") {
    return `/uploads/${encodeURIComponent(photo)}?v=${photoRefreshKey}`;
  }

  return null;
};

// end of setup helpers
 if (loading) {
  return (
    <div className="property-details-container">
      <h2>Loading property details...</h2>
    </div>
  );
}

if (!property) {
  return (
    <div className="property-details-container">
      <h2>No property found.</h2>
      <button className="back-btn" onClick={() => navigate("/PropertiesList")}>
        Go Back
      </button>
    </div>
  );
}

  const tabs = [
  "Property Details",
  "Contact Details",
  "Documents",
  "Seasonal Trends",
  "Facilities",
  "Room Type",
  "Rate Plan with Rates",
  "Policy Details",
  "Payment Methods",
  "OTA Information",
  "Credentials",
  "Extra Charges",
  "FAQ",
];
// EDIT PHASE MAY 15 2026 STARTS
  const currentData = isEditing ? editProperty : property;

const handleEditClick = () => {
  if (!canEditProperty) {
    alert("Access denied. You are not allowed to edit property details.");
    return;
  }

  setEditProperty({ ...property });
  setIsEditing(true);
};

  // PHASE 2 MAY 15 2026
const handleFieldChange = (field, value) => {
  let finalValue = value;

  // Numeric-only fields
if (
  field === "pinCode" ||
  field === "receptionNumber" ||
  field === "marketingNumber" ||
  field === "ownerMobileNumber" ||
  field === "managerMobileNumber" ||
  field === "billingMobileNumber" ||
  field === "mobileNumberForUpdation" ||
  field === "phoneNumberTripadvisor" ||
  field === "accountNumber"
) {
  finalValue = value.replace(/\D/g, "");
}

  // GST should always be uppercase and alphanumeric
  if (field === "gst") {
    finalValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  }

  setEditProperty((prev) => ({
    ...prev,
    [field]: finalValue,
  }));
};
  // ENDS HERE

const handleDiscard = () => {
  setEditProperty({ ...property });
  setIsEditing(false);
};

const handleSave = async () => {
  if (!canEditProperty) {
    alert("Access denied. You are not allowed to save property changes.");
    setIsEditing(false);
    return;
  }

  if (!propertyId) {
    alert("Property ID missing. Please reopen this property from the list.");
    return;
  }

  try {
    setSaving(true);

    const res = await axios.put(
  `${API_BASE}/api/properties/${propertyId}`,
  {
    ...editProperty,
    updatedBy: loggedInUser,
    updatedByRole: loggedInRole,
  }
);

    setProperty(res.data.property || editProperty);
    setEditProperty(res.data.property || editProperty);
    setIsEditing(false);

    alert("Property updated successfully!");
  } catch (err) {
    console.error("Update property error:", err.response?.data || err.message);
    alert("Failed to update property. Please try again.");
  } finally {
    setSaving(false);
  }
};

// REUSBALE INPUTS
const renderEditableValue = (field, fallback = "—", listId = "") => {
  const value = currentData?.[field] ?? "";

  if (!isEditing) {
    return value ? value : <span style={{ color: "red" }}>{fallback}</span>;
  }

  const numericFields = [
  "pinCode",
  "receptionNumber",
  "marketingNumber",
  "ownerMobileNumber",
  "managerMobileNumber",
  "billingMobileNumber",
  "mobileNumberForUpdation",
  "phoneNumberTripadvisor",
  "accountNumber",
];

  const isNumericField = numericFields.includes(field);
  const isGstField = field === "gst";

  return (
    <input
      className="edit-input"
      type="text"
      inputMode={isNumericField ? "numeric" : "text"}
      pattern={isNumericField ? "[0-9]*" : undefined}
      value={value}
      list={listId || undefined}
      maxLength={
  field === "pinCode"
    ? 6
    : field === "receptionNumber" ||
      field === "marketingNumber" ||
      field === "ownerMobileNumber" ||
      field === "managerMobileNumber" ||
      field === "billingMobileNumber" ||
      field === "mobileNumberForUpdation" ||
      field === "phoneNumberTripadvisor"
    ? 10
    : field === "accountNumber"
    ? 18
    : isGstField
    ? 15
    : undefined
}
      style={{
        textTransform: isGstField ? "uppercase" : "none",
      }}
      onChange={(e) => handleFieldChange(field, e.target.value)}
    />
  );
};
// NEW LOGIC FOR MULTISELECT
  const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const normalizeMultiValue = (value) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value;
  }

  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

const handleMultiSelectChange = (field, selectedOptions) => {
  const values = Array.from(selectedOptions, (option) => option.value);

  setEditProperty((prev) => ({
    ...prev,
    [field]: values,
  }));
};

const renderSeasonMultiSelect = (field, selectedClass = "") => {
  const value = normalizeMultiValue(currentData?.[field]);

  if (!isEditing) {
    return value.length > 0 ? (
      value.join(", ")
    ) : (
      <span style={{ color: "red" }}>Not Mentioned</span>
    );
  }

  return (
    <div className="seasons-group">
      <select
        multiple
        className="multi-select"
        name={field}
        value={value}
        onChange={(e) => handleMultiSelectChange(field, e.target.selectedOptions)}
      >
        {monthsList.map((month) => (
          <option
            key={month}
            value={month}
            className={value.includes(month) ? selectedClass : ""}
          >
            {month}
          </option>
        ))}
      </select>

      <small>'Ctrl + Click' or 'Drag + Click'</small>
    </div>
  );
};
  // ENDS HERE

  // FACILITES EDIT OPTION 18 MAY 2026 STARTS HERE
 const isAmenityYes = (value) => {
  return (
    value === true ||
    value === 1 ||
    String(value).toLowerCase() === "yes"
  );
};

const handleAmenityStatusChange = (field, value, chargeField = null) => {
  setEditProperty((prev) => ({
    ...prev,
    [field]: value,
    ...(value !== "Yes" && chargeField ? { [chargeField]: "" } : {}),
  }));
};

const handleAmenityChargeChange = (chargeField, value) => {
  const numericValue = value.replace(/\D/g, "");

  setEditProperty((prev) => ({
    ...prev,
    [chargeField]: numericValue,
  }));
};

const renderAmenityStatus = (field, chargeField = null) => {
  const currentValue = currentData?.[field];
  const chargeValue = currentData?.[chargeField] ?? "";

  if (!isEditing) {
    if (!isAmenityYes(currentValue)) {
      return <span style={{ color: "red" }}>No</span>;
    }

    if (chargeField) {
      return chargeValue ? `Charges - ₹${chargeValue}` : "Yes";
    }

    return "Yes";
  }

  const statusValue =
    currentValue === true || currentValue === 1
      ? "Yes"
      : currentValue === false || currentValue === 0 || currentValue === undefined || currentValue === null
      ? "No"
      : currentValue;

  return (
    <div className="amenity-edit-cell">
      <select
        className="edit-input"
        value={statusValue}
        onChange={(e) =>
          handleAmenityStatusChange(field, e.target.value, chargeField)
        }
      >
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>

      {chargeField && statusValue === "Yes" && (
        <input
          className="edit-input amenity-charge-input"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="Enter charges"
          value={chargeValue}
          onChange={(e) =>
            handleAmenityChargeChange(chargeField, e.target.value)
          }
        />
      )}
    </div>
  );
};

const renderAmenitySection = (title, rows) => {
  return (
    <div className="facility-block">
      <h4 className="facility-heading" style={{ color: "#2e7d32" }}>
        {title}
      </h4>

      <table className="facility-table">
        <thead>
          <tr>
            <th>Facility</th>
            <th>Status / Charges</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((item) => (
            <tr key={item.key}>
              <td>{item.label}</td>
              <td>{renderAmenityStatus(item.key, item.chargeKey)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
  // ENDS HERE

  // EXTRA CHARGES FEATURE STARTS HERE 
  // EXTRA CHARGES EDIT HELPERS START
const getExtraChargesRows = () => {
  const source = currentData?.extraCharges;

  if (Array.isArray(source) && source.length > 0) {
    return source;
  }

  return [
    {
      extraChargeName: "",
      extraChargePrice: "",
      extraPercentageCharged: "",
    },
  ];
};

const handleExtraChargeChange = (index, field, value) => {
  let finalValue = value;

  if (field === "extraChargePrice") {
    finalValue = value.replace(/\D/g, "");
  }

  setEditProperty((prev) => {
    const existingRows = Array.isArray(prev?.extraCharges)
      ? [...prev.extraCharges]
      : [];

    if (!existingRows[index]) {
      existingRows[index] = {
        extraChargeName: "",
        extraChargePrice: "",
        extraPercentageCharged: "",
      };
    }

    existingRows[index] = {
      ...existingRows[index],
      [field]: finalValue,
    };

    return {
      ...prev,
      extraCharges: existingRows,
    };
  });
};

const addExtraChargeRow = () => {
  setEditProperty((prev) => ({
    ...prev,
    extraCharges: [
      ...(Array.isArray(prev?.extraCharges) ? prev.extraCharges : []),
      {
        extraChargeName: "",
        extraChargePrice: "",
        extraPercentageCharged: "",
      },
    ],
  }));
};

const removeExtraChargeRow = (index) => {
  setEditProperty((prev) => {
    const existingRows = Array.isArray(prev?.extraCharges)
      ? [...prev.extraCharges]
      : [];

    existingRows.splice(index, 1);

    return {
      ...prev,
      extraCharges:
        existingRows.length > 0
          ? existingRows
          : [
              {
                extraChargeName: "",
                extraChargePrice: "",
                extraPercentageCharged: "",
              },
            ],
    };
  });
};
// EXTRA CHARGES EDIT HELPERS END
  // OTA INFORMATION START HERE
  // OTA INFORMATION EDIT HELPERS START
const getOtaInfoRows = () => {
  const source = currentData?.otaInfo;

  if (Array.isArray(source) && source.length > 0) {
    return source;
  }

  return [
    {
      otaName: "",
      propertyCode: "",
      otaUserName: "",
      otaPassword: "",
    },
  ];
};

const handleOtaInfoChange = (index, field, value) => {
  setEditProperty((prev) => {
    const existingRows = Array.isArray(prev?.otaInfo)
      ? [...prev.otaInfo]
      : [];

    if (!existingRows[index]) {
      existingRows[index] = {
        otaName: "",
        propertyCode: "",
        otaUserName: "",
        otaPassword: "",
      };
    }

    existingRows[index] = {
      ...existingRows[index],
      [field]: value,
    };

    return {
      ...prev,
      otaInfo: existingRows,
    };
  });
};

const addOtaInfoRow = () => {
  setEditProperty((prev) => ({
    ...prev,
    otaInfo: [
      ...(Array.isArray(prev?.otaInfo) ? prev.otaInfo : []),
      {
        otaName: "",
        propertyCode: "",
        otaUserName: "",
        otaPassword: "",
      },
    ],
  }));
};

const removeOtaInfoRow = (index) => {
  setEditProperty((prev) => {
    const existingRows = Array.isArray(prev?.otaInfo)
      ? [...prev.otaInfo]
      : [];

    existingRows.splice(index, 1);

    return {
      ...prev,
      otaInfo:
        existingRows.length > 0
          ? existingRows
          : [
              {
                otaName: "",
                propertyCode: "",
                otaUserName: "",
                otaPassword: "",
              },
            ],
    };
  });
};
// OTA INFORMATION EDIT HELPERS END

  // RATE PLAN HELPER START HERE
  // RATE PLAN EDIT HELPERS START
const getRatePlanRows = () => {
  const source = currentData?.ratePlans;

  if (Array.isArray(source) && source.length > 0) {
    return source;
  }

  return [
    {
      roomTypeName: "",
      ratePlanName: "",
      baseRates: "",
      extraAdultRate: "",
      extraChildRate: "",
      cpBreakfast: "",
      mapBreakfast: "",
      mapLunch: "",
      apBreakfast: "",
      apLunch: "",
      apDinner: "",
    },
  ];
};

const handleRatePlanChange = (index, field, value) => {
  let finalValue = value;

  const numericFields = [
    "baseRates",
    "extraAdultRate",
    "extraChildRate",
    "cpBreakfast",
    "mapBreakfast",
    "mapLunch",
    "apBreakfast",
    "apLunch",
    "apDinner",
  ];

  if (numericFields.includes(field)) {
    finalValue = value.replace(/\D/g, "");
  }

  setEditProperty((prev) => {
    const existingRows = Array.isArray(prev?.ratePlans)
      ? [...prev.ratePlans]
      : [];

    if (!existingRows[index]) {
      existingRows[index] = {
        roomTypeName: "",
        ratePlanName: "",
        baseRates: "",
        extraAdultRate: "",
        extraChildRate: "",
        cpBreakfast: "",
        mapBreakfast: "",
        mapLunch: "",
        apBreakfast: "",
        apLunch: "",
        apDinner: "",
      };
    }

    existingRows[index] = {
      ...existingRows[index],
      [field]: finalValue,
    };

    return {
      ...prev,
      ratePlans: existingRows,
    };
  });
};

const addRatePlanRow = () => {
  setEditProperty((prev) => ({
    ...prev,
    ratePlans: [
      ...(Array.isArray(prev?.ratePlans) ? prev.ratePlans : []),
      {
        roomTypeName: "",
        ratePlanName: "",
        baseRates: "",
        extraAdultRate: "",
        extraChildRate: "",
        cpBreakfast: "",
        mapBreakfast: "",
        mapLunch: "",
        apBreakfast: "",
        apLunch: "",
        apDinner: "",
      },
    ],
  }));
};

const removeRatePlanRow = (index) => {
  setEditProperty((prev) => {
    const existingRows = Array.isArray(prev?.ratePlans)
      ? [...prev.ratePlans]
      : [];

    existingRows.splice(index, 1);

    return {
      ...prev,
      ratePlans:
        existingRows.length > 0
          ? existingRows
          : [
              {
                roomTypeName: "",
                ratePlanName: "",
                baseRates: "",
                extraAdultRate: "",
                extraChildRate: "",
                cpBreakfast: "",
                mapBreakfast: "",
                mapLunch: "",
                apBreakfast: "",
                apLunch: "",
                apDinner: "",
              },
            ],
    };
  });
};

const toNumber = (value) => {
  const num = Number(value || 0);
  return Number.isNaN(num) ? 0 : num;
};

const calculateMealPriceOnly = (plan, rp) => {
  if (plan === "EP") {
  return 0;
}

  if (plan === "CP") {
    return toNumber(rp.cpBreakfast);
  }

  if (plan === "MAP") {
    return toNumber(rp.mapBreakfast) + toNumber(rp.mapLunch);
  }

  if (plan === "AP") {
    return (
      toNumber(rp.apBreakfast) +
      toNumber(rp.apLunch) +
      toNumber(rp.apDinner)
    );
  }

  return 0;
};

const calculateTotalRatePlan = (plan, rp) => {
  return toNumber(rp.baseRates) + calculateMealPriceOnly(plan, rp);
};

const renderRatePlanInput = (index, row, field, listId = "") => {
  return (
    <input
      className="edit-input"
      type="text"
      list={listId || undefined}
      value={row[field] || ""}
      inputMode={
        [
          "baseRates",
          "extraAdultRate",
          "extraChildRate",
          "cpBreakfast",
          "mapBreakfast",
          "mapLunch",
          "apBreakfast",
          "apLunch",
          "apDinner",
        ].includes(field)
          ? "numeric"
          : "text"
      }
      pattern={
        [
          "baseRates",
          "extraAdultRate",
          "extraChildRate",
          "cpBreakfast",
          "mapBreakfast",
          "mapLunch",
          "apBreakfast",
          "apLunch",
          "apDinner",
        ].includes(field)
          ? "[0-9]*"
          : undefined
      }
      onChange={(e) => handleRatePlanChange(index, field, e.target.value)}
    />
  );
};
// RATE PLAN EDIT HELPERS END
  const handleDocumentDelete  = async (docKey) => {
  if (!canEditProperty) {
    alert("Access denied. You are not allowed to delete documents.");
    return;
  }
  if (!propertyId) {
    alert("Property ID missing. Please reopen this property from the list.");
    return;
  }

  const confirmDelete = window.confirm(
    "Are you sure you want to delete this uploaded document?"
  );

  if (!confirmDelete) return;

  try {
    setUploadingDocs(true);

    await axios.delete(
  `${API_BASE}/api/properties/${propertyId}/document/${docKey}`,
  {
    data: {
      deletedBy: loggedInUser || "Unknown",
      deletedByRole: loggedInRole || "",
    },
  }
);

    setProperty((prev) => ({
  ...prev,
  [docKey]: "",
  documentStatus: {
    ...(prev?.documentStatus || {}),
    [docKey]: {
      hasFile: false,
      fileName: "",
      contentType: "",
      size: 0,
    },
  },
}));

setEditProperty((prev) => ({
  ...prev,
  [docKey]: "",
  documentStatus: {
    ...(prev?.documentStatus || {}),
    [docKey]: {
      hasFile: false,
      fileName: "",
      contentType: "",
      size: 0,
    },
  },
}));

    setDocUploads((prev) => ({
      ...prev,
      [docKey]: null,
    }));

    alert("Document deleted successfully!");
  } catch (err) {
    console.error("Delete document error:", err.response?.data || err.message);
    alert("Failed to delete document. Please try again.");
  } finally {
    setUploadingDocs(false);
  }
};

  // ROOM TYPE EDITS
  // ROOM TYPE EDIT HELPERS START
const roomTypeNumericFields = [
  "baseAdult",
  "baseChild",
  "maxAdult",
  "maxChild",
  "maxOccupancy",
  "roomInventory",
  "rateThresholdMin",
  "rateThresholdMax",
  "bedsCountPerRoom",
  "extraMattressCount",
  "extraMattressPriceAdult",
  "extraMattressPriceChild",
  "numberOfWashrooms",
];

const allRoomAmenities = [
  { key: "Ac", label: "Ac" },
  { key: "ceilingFan", label: "Ceiling Fan" },
  { key: "wallFan", label: "Wall Fan" },
  { key: "heater", label: "Heater" },
  { key: "flatScreenTv", label: "Flat screen TV" },
  { key: "foldupBed", label: "Foldup bed" },
  { key: "sofaBed", label: "Sofa bed" },
  { key: "sofa", label: "Sofa" },
  { key: "radio", label: "Radio" },
  { key: "videoGames", label: "Video Games" },
  { key: "trashCans", label: "Trash cans" },
  { key: "landline", label: "Landline" },
  { key: "dressingRoomTable", label: "Dressing room/table" },
  { key: "washingMachine", label: "Washing Machine" },
  { key: "seatingArea", label: "Seating area" },
  { key: "iron", label: "Iron" },
  { key: "desk", label: "Desk" },
  { key: "socketNearBed", label: "Socket near bed" },
  { key: "featherPillow", label: "Feather Pillow" },
  { key: "blankets", label: "Blankets" },
  { key: "geyserHotWater", label: "Geyser/hot water" },
  { key: "minifridge", label: "Minifridge" },
  { key: "others", label: "OTHERS" },

  { key: "freeToiletries", label: "Free Toiletries" },
  { key: "pvtBathroom", label: "Pvt Bathroom" },
  { key: "sharedBathroom", label: "Shared Bathroom" },
  { key: "toilet", label: "Toilet" },
  { key: "toiletPaper", label: "Toilet Paper" },
  { key: "bathTub", label: "Bath tub" },
  { key: "bathRobe", label: "Bathrobe" },
  { key: "shower", label: "Shower" },
  { key: "towel", label: "Towel" },
  { key: "hairdryer", label: "Hairdryer" },
  { key: "slippers", label: "Slippers" },
  { key: "spaBath", label: "Spa Bath" },
  { key: "clothRack", label: "Cloth rack" },
  { key: "dryingRack", label: "Drying rack" },
  { key: "toothBrush", label: "Tooth Brush" },
  { key: "toothPaste", label: "Tooth Paste" },
  { key: "shampoo", label: "Shampoo" },
  { key: "conditioner", label: "Conditioner" },
  { key: "bodySoap", label: "Body soap" },
  { key: "showerCap", label: "Shower cap" },

  { key: "electricKettle", label: "Electric Kettle" },
  { key: "diningArea", label: "Dining area" },
  { key: "diningTable", label: "Dining table" },
  { key: "toaster", label: "Toaster" },
  { key: "waterBottle", label: "Water Bottle" },
  { key: "gasStove", label: "Gas Stove" },
  { key: "dishWasher", label: "Dish Washer" },
  { key: "outdoorDiningArea", label: "Outdoor Dining area" },
  { key: "kitchen", label: "Kitchen" },
  { key: "minibar", label: "Minibar" },
  { key: "microwave", label: "Microwave" },
  { key: "refrigerator", label: "Refrigerator" },
  { key: "teaCoffeeMaker", label: "Tea / Coffee Maker" },

  { key: "wineGlasses", label: "Wine glasses" },
  { key: "chocolateCookies", label: "Chocolate/Cookies" },
  { key: "kidMeals", label: "Kid Meals" },
  { key: "wineChampagne", label: "Wine/Champagne" },
  { key: "barbeque", label: "Barbeque" },
  { key: "buffet", label: "Buffet" },

  { key: "fireAlarm", label: "Fire Alarm" },
  { key: "fireExtinguisherInsideRoom", label: "Fire Extinguisher Inside Rooms" },
  { key: "lockersInsideRooms", label: "Lockers Inside Rooms" },
  { key: "alarmClock", label: "Alarm clock" },
  { key: "wakeUpService", label: "Wake up service" },
  { key: "executiveLoungeAccess", label: "Executive lounge access" },
];

const getRoomTypeRows = () => {
  const source = currentData?.roomTypes;

  if (Array.isArray(source) && source.length > 0) {
    return source;
  }

  return [
    {
      roomTypeName: "",
      roomSize: "",
      roomNumbers: "",
      baseAdult: "",
      baseChild: "",
      maxAdult: "",
      maxChild: "",
      maxOccupancy: "",
      roomInventory: "",
      rateThresholdMin: "",
      rateThresholdMax: "",
      roomPhotographs: [],
      amenities: {},
      comments: "",
    },
  ];
};

const handleRoomTypeFieldChange = (index, field, value) => {
  let finalValue = value;

  if (roomTypeNumericFields.includes(field)) {
    finalValue = value.replace(/\D/g, "");
  }

  setEditProperty((prev) => {
    const rows = Array.isArray(prev?.roomTypes) ? [...prev.roomTypes] : [];

    if (!rows[index]) {
      rows[index] = {
        roomTypeName: "",
        roomSize: "",
        roomNumbers: "",
        baseAdult: "",
        baseChild: "",
        maxAdult: "",
        maxChild: "",
        maxOccupancy: "",
        roomInventory: "",
        rateThresholdMin: "",
        rateThresholdMax: "",
        roomPhotographs: [],
        amenities: {},
        comments: "",
      };
    }

    rows[index] = {
      ...rows[index],
      [field]: finalValue,
    };

    return {
      ...prev,
      roomTypes: rows,
    };
  });
};

const addRoomTypeRow = () => {
  setEditProperty((prev) => ({
    ...prev,
    roomTypes: [
      ...(Array.isArray(prev?.roomTypes) ? prev.roomTypes : []),
      {
        roomTypeName: "",
        roomSize: "",
        roomNumbers: "",
        baseAdult: "",
        baseChild: "",
        maxAdult: "",
        maxChild: "",
        maxOccupancy: "",
        roomInventory: "",
        rateThresholdMin: "",
        rateThresholdMax: "",
        roomPhotographs: [],
        amenities: {},
        comments: "",
      },
    ],
  }));
};

const removeRoomTypeRow = (index) => {
  setEditProperty((prev) => {
    const rows = Array.isArray(prev?.roomTypes) ? [...prev.roomTypes] : [];

    rows.splice(index, 1);

    return {
      ...prev,
      roomTypes:
        rows.length > 0
          ? rows
          : [
              {
                roomTypeName: "",
                roomSize: "",
                roomNumbers: "",
                baseAdult: "",
                baseChild: "",
                maxAdult: "",
                maxChild: "",
                maxOccupancy: "",
                roomInventory: "",
                rateThresholdMin: "",
                rateThresholdMax: "",
                roomPhotographs: [],
                amenities: {},
                comments: "",
              },
            ],
    };
  });
};

const renderRoomTypeInput = (index, room, field, placeholder = "") => {
  const isNumeric = roomTypeNumericFields.includes(field);

  return (
    <input
      className="edit-input"
      type="text"
      value={room[field] || ""}
      placeholder={placeholder}
      inputMode={isNumeric ? "numeric" : "text"}
      pattern={isNumeric ? "[0-9]*" : undefined}
      onChange={(e) =>
        handleRoomTypeFieldChange(index, field, e.target.value)
      }
    />
  );
};

const getRoomPhotos = (room) => {
  if (Array.isArray(room.roomPhotographs)) return room.roomPhotographs;
  if (room.roomPhotographs) return [room.roomPhotographs];
  return [];
};

// const handleRoomPhotoAdd = (index, files) => {
//   const selectedFiles = Array.from(files || []);

//   setEditProperty((prev) => {
//     const rows = Array.isArray(prev?.roomTypes) ? [...prev.roomTypes] : [];
//     const room = rows[index] || {};
//     const existingPhotos = getRoomPhotos(room);

//     if (existingPhotos.length + selectedFiles.length > 4) {
//       alert("You can upload maximum 4 room photographs.");
//       return prev;
//     }

//     rows[index] = {
//       ...room,
//       roomPhotographs: [...existingPhotos, ...selectedFiles],
//     };

//     return {
//       ...prev,
//       roomTypes: rows,
//     };
//   });
// };

const removeRoomPhoto = async (roomIndex, photoIndex) => {
  if (!canEditProperty) {
    alert("Access denied. You are not allowed to delete room photos.");
    return;
  }

  if (!propertyId) {
    alert("Property ID missing. Please reopen this property from the list.");
    return;
  }

  const confirmDelete = window.confirm(
    "Are you sure you want to remove this room photo?"
  );

  if (!confirmDelete) return;

  try {
    await axios.delete(
  `${API_BASE}/api/properties/${propertyId}/room-photo/${roomIndex}/${photoIndex}`,
  {
    data: {
      deletedBy: loggedInUser || "Unknown",
      deletedByRole: loggedInRole || "",
    },
  }
);

    const refreshed = await axios.get(`${API_BASE}/api/properties/${propertyId}`);

    setPhotoRefreshKey(Date.now());
    setProperty(refreshed.data);
    setEditProperty(refreshed.data);

    alert("Room photo removed successfully.");
  } catch (err) {
    console.error("Room photo delete failed:", err.response?.data || err);
    alert(err.response?.data?.message || "Failed to remove room photo.");
  }
};

const getRoomAmenitiesObject = (room) => {
  if (room?.amenities && typeof room.amenities === "object") {
    return room.amenities;
  }

  const amenities = {};

  allRoomAmenities.forEach((item) => {
    if (room?.[item.key]) {
      amenities[item.key] = true;
    }
  });

  return amenities;
};

const getSelectedRoomAmenities = (room) => {
  const amenities = getRoomAmenitiesObject(room);

  return allRoomAmenities.filter((item) => amenities[item.key]);
};

const getAvailableRoomAmenities = (room) => {
  const amenities = getRoomAmenitiesObject(room);

  return allRoomAmenities.filter((item) => !amenities[item.key]);
};

const addRoomAmenities = (roomIndex, amenityKeys) => {
  if (!amenityKeys || amenityKeys.length === 0) return;

  setEditProperty((prev) => {
    const rows = Array.isArray(prev?.roomTypes) ? [...prev.roomTypes] : [];
    const room = rows[roomIndex] || {};
    const amenities = getRoomAmenitiesObject(room);

    amenityKeys.forEach((key) => {
      amenities[key] = true;
    });

    rows[roomIndex] = {
      ...room,
      amenities,
    };

    return {
      ...prev,
      roomTypes: rows,
    };
  });
};

const removeRoomAmenity = (roomIndex, amenityKey) => {
  setEditProperty((prev) => {
    const rows = Array.isArray(prev?.roomTypes) ? [...prev.roomTypes] : [];
    const room = rows[roomIndex] || {};
    const amenities = { ...getRoomAmenitiesObject(room) };

    delete amenities[amenityKey];

    rows[roomIndex] = {
      ...room,
      amenities,
    };

    return {
      ...prev,
      roomTypes: rows,
    };
  });
};
// ROOM TYPE EDIT HELPERS END
  // ENDS HERE
  
const renderEditActions = () => {
  if (!isEditing || !canEditProperty) return null;

  return (
    <div className="tab-edit-actions">
      <button className="save-btn" onClick={handleSave} disabled={saving}>
        {saving ? "Saving..." : "Save"}
      </button>

      <button className="discard-btn" onClick={handleDiscard} disabled={saving}>
        Discard
      </button>
    </div>
  );
};
  // ENDS HERE
  
  const renderTable = () => {
    switch (activeTab) {
      case "Property Details":
return (
  <>
    <table className="property-table">
      <thead>
        <tr>
          <th>Field</th>
          <th>Details</th>
        </tr>
      </thead>

      <tbody>
        {/* <tr><td>ID</td><td>{property.id || property._id || <span style={{ color: "red" }}>—</span>}</td></tr> */} 

        <tr><td>Property Name</td><td>{renderEditableValue("propertyName")}</td></tr>
        <tr><td>Property Type</td><td>{renderEditableValue("propertyType", "—", "property-type-options")}</td></tr>
        <tr><td>Property Address</td><td>{renderEditableValue("PropertyAddress")}</td></tr>
        <tr><td>Country</td><td>{renderEditableValue("country")}</td></tr>
        <tr><td>State</td><td>{renderEditableValue("state", "—", "state-options")}</td></tr>
        <tr><td>City</td><td>{renderEditableValue("city", "—", "city-options")}</td></tr>
        <tr><td>Pin Code</td><td>{renderEditableValue("pinCode")}</td></tr>
        <tr><td>Bill to Company</td><td>{renderEditableValue("bill")}</td></tr>
        <tr><td>GST Number</td><td>{renderEditableValue("gst")}</td></tr>
        <tr><td>Reception No.</td><td>{renderEditableValue("receptionNumber")}</td></tr>
        <tr><td>Marketing No.</td><td>{renderEditableValue("marketingNumber")}</td></tr>
        <tr><td>Property Email</td><td>{renderEditableValue("propertyEmail")}</td></tr>
        <tr><td>Property Website URL</td><td>{renderEditableValue("propertyWebsite")}</td></tr>
        <tr><td>Invoice Number Reset</td><td>{renderEditableValue("invoiceNumber", "—", "invoice-reset-options")}</td></tr>
        <tr><td>Rates Inclusive/Exclusive</td><td>{renderEditableValue("ratesAre", "—", "rates-tax-options")}</td></tr>
        <tr><td>Star Category</td><td>{renderEditableValue("starCategory", "—", "star-category-options")}</td></tr>
        <tr><td>Import Future Bookings</td><td>{renderEditableValue("importFuture", "—", "yes-no-options")}</td></tr>
        <tr><td>Check-In Time</td><td>{renderEditableValue("checkIn", "—", "time-options")}</td></tr>
        <tr><td>Check-Out Time</td><td>{renderEditableValue("checkOut", "—", "time-options")}</td></tr>
        <tr><td>Total Number of Floors</td><td>{renderEditableValue("buildingFloors", "—", "floor-options")}</td></tr>
        <tr><td>Total Number of Rooms</td><td>{renderEditableValue("buildingRooms")}</td></tr>
        <tr><td>Property Comment</td><td>{renderEditableValue("propertyComments")}</td></tr>
      </tbody>
    </table>

    {renderEditActions()}
  </>
);

    case "Contact Details":
  return (
    <>
      <div>
        {/* Owner Details */}
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ marginBottom: "10px", color: "#333" }}>
            Owner Details
          </h3>

          <table className="property-table">
            <thead>
              <tr>
                <th>Contact Person Name</th>
                <th>Designation</th>
                <th>Date of Birth</th>
                <th>State/City of Owner</th>
                <th>Email Address</th>
                <th>Mobile Number</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{renderEditableValue("ownerContactName")}</td>
                <td>
                  {renderEditableValue(
                    "ownerDesignation",
                    "—",
                    "owner-designation-options"
                  )}
                </td>
                <td>{renderEditableValue("ownerDOB", "—")}</td>
                <td>{renderEditableValue("ownerStateCity", "—")}</td>
                <td>{renderEditableValue("ownerEmail")}</td>
                <td>{renderEditableValue("ownerMobileNumber")}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Manager Details */}
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ marginBottom: "10px", color: "#333" }}>
            Manager Details
          </h3>

          <table className="property-table">
            <thead>
              <tr>
                <th>Contact Person Name</th>
                <th>Designation</th>
                <th>Email Address</th>
                <th>Mobile Number</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{renderEditableValue("managerContactName")}</td>
                <td>
                  {renderEditableValue(
                    "managerDesignation",
                    "—",
                    "manager-designation-options"
                  )}
                </td>
                <td>{renderEditableValue("managerEmail")}</td>
                <td>{renderEditableValue("managerMobileNumber")}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Billing Details */}
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ marginBottom: "10px", color: "#333" }}>
            Billing / Invoice Related Matters
          </h3>

          <table className="property-table">
            <thead>
              <tr>
                <th>Contact Person Name</th>
                <th>Designation</th>
                <th>Email Address</th>
                <th>Mobile Number</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{renderEditableValue("billingContactName")}</td>
                <td>{renderEditableValue("billingDesignation")}</td>
                <td>{renderEditableValue("billingEmail")}</td>
                <td>{renderEditableValue("billingMobileNumber")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {renderEditActions()}
    </>
  );


    case "Documents": {
  const documents = [
    { label: "GST Certificate", key: "gstCertificate" },
    { label: "Lease / Rent Agreement", key: "leaseAgreement" },
    { label: "MSME Document", key: "msmeDocument" },
    { label: "Letter Head", key: "letterHead" },
    { label: "Utility Bill", key: "utilityBill" },
    { label: "Aadhaar Card", key: "aadhaarCard" },
    { label: "PAN Card", key: "panCard" },
    { label: "Other Document", key: "otherDocument" },
  ];

  return (
    <>
      <div className="documents-section">
        <h3 style={{ marginBottom: "10px" }}>Documents</h3>

        <table className="property-table">
          <thead>
            <tr>
              <th>Document Type</th>
              <th>File</th>
              <th>Status</th>
              <th>Download</th>
              {isEditing && <th>Upload / Re-upload</th>}
            </tr>
          </thead>

          <tbody>
            {documents.map((doc, i) => {
              const storedValue = property[doc.key];
              const fileURL = buildDocumentURL(doc.key, storedValue);

              const isPdf =
                typeof storedValue === "string" &&
                storedValue.toLowerCase().endsWith(".pdf");

              return (
                <tr key={i}>
                  <td>{doc.label}</td>

                  {/* FILE PREVIEW */}
                  <td>
                    {fileURL ? (
                      isPdf ? (
                        <a
                          href={fileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007bff", textDecoration: "underline" }}
                        >
                          View PDF
                        </a>
                      ) : (
                       <img
  src={fileURL}
  alt={doc.label}
  onError={(e) => {
    console.error("Document preview failed:", fileURL);
    e.currentTarget.style.display = "none";
  }}
  style={{
    width: "80px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "6px",
  }}
/>
                      )
                    ) : (
                      <span style={{ color: "red" }}>—</span>
                    )}
                  </td>

                  {/* STATUS */}
                  <td
                    style={{
                      fontWeight: 500,
                      color: storedValue ? "green" : "red",
                    }}
                  >
                    {storedValue ? "Uploaded" : "No"}
                  </td>

                  {/* DOWNLOAD */}
                  <td>
                    {fileURL ? (
                     <a
  href={fileURL}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "13px",
    fontWeight: "500",
  }}
>
  View / Download
</a>
                    ) : (
                      "—"
                    )}
                  </td>

                  {/* UPLOAD / RE-UPLOAD / DELETE */}
                  {isEditing && (
                    <td>
                      <div className="payment-doc-actions">
                        <label className="upload-inline-label">
                          {storedValue ? "Re-upload" : "Upload"}
                          <input
                            type="file"
                            accept="image/*,.pdf"
                            onChange={(e) =>
                              setDocUploads((prev) => ({
                                ...prev,
                                [doc.key]: e.target.files[0],
                              }))
                            }
                          />
                        </label>

                        {storedValue && (
                          <button
                            type="button"
                            className="delete-doc-btn"
                            onClick={() => handleDocumentDelete(doc.key)}
                            disabled={uploadingDocs}
                          >
                            Delete
                          </button>
                        )}
                      </div>

                      {docUploads[doc.key] && (
                        <div style={{ fontSize: "12px", marginTop: "5px" }}>
                          Selected: {docUploads[doc.key].name}
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>

        {isEditing && (
          <button
            type="button"
            className="save-btn"
            style={{ marginTop: "12px" }}
            onClick={handleDocUpload}
            disabled={uploadingDocs}
          >
            {uploadingDocs ? "Uploading..." : "Upload Selected Documents"}
          </button>
        )}

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {renderEditableValue("documentComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}





     case "Seasonal Trends":
  return (
    <>
      <div className="seasonal-trends" style={{ marginTop: "20px" }}>
        <h3 style={{ marginBottom: "10px" }}>Seasonal Trends</h3>

        <table className="property-table">
          <thead>
            <tr>
              <th>Season Type</th>
              <th>Months</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style={{ fontWeight: "600", color: "#1a73e8" }}>
                Peak Season
              </td>
              <td>{renderSeasonMultiSelect("peakSeasons", "peak-selected")}</td>
            </tr>

            <tr>
              <td style={{ fontWeight: "600", color: "#f57c00" }}>
                Mid Season
              </td>
              <td>{renderSeasonMultiSelect("midSeasons", "mid-selected")}</td>
            </tr>

            <tr>
              <td style={{ fontWeight: "600", color: "#d32f2f" }}>
                Low Season
              </td>
              <td>{renderSeasonMultiSelect("lowSeasons", "low-selected")}</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {renderEditableValue("seasonalTrendsComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );

      
     case "Facilities": {
  const facilitySections = [
    {
      title: "Most Popular Facilities",
      rows: [
        { label: "Restaurant", key: "Restaurant" },
        { label: "Terrace", key: "Terrace" },
        { label: "Lift", key: "Lift" },
        { label: "WiFi", key: "WiFi" },
        { label: "24/7 Service", key: "TwentyFourService" },
        { label: "Air Conditioner", key: "AirConditioner" },
        { label: "Garden", key: "Garden" },
        { label: "Room Service", key: "RoomService" },
        { label: "Bar", key: "Bar" },
      ],
    },
    {
      title: "Chargeable Facilities",
      rows: [
        { label: "Sauna", key: "Sauna", chargeKey: "SaunaCharges" },
        {
          label: "Airport Shuttle",
          key: "AirportShuttle",
          chargeKey: "AirportShuttleCharges",
        },
        { label: "Jacuzzi", key: "Jacuzzi", chargeKey: "JacuzziCharges" },
        {
          label: "Water Park",
          key: "WaterPark",
          chargeKey: "WaterParkCharges",
        },
        { label: "Spa", key: "Spa", chargeKey: "SpaCharges" },
        { label: "Parking", key: "Parking", chargeKey: "ParkingCharges" },
        {
          label: "Facility for Disabled",
          key: "FacilityforDisabled",
          chargeKey: "FacilityforDisabledCharges",
        },
        {
          label: "Game Room",
          key: "GameRoom",
          chargeKey: "GameRoomCharges",
        },
        {
          label: "Private Taxi",
          key: "PrivateTaxi",
          chargeKey: "PrivateTaxiCharges",
        },
      ],
    },
    {
      title: "Pool Amenities",
      rows: [
        { label: "Pool Cover", key: "PoolCover" },
        { label: "Pool Towels", key: "PoolTowels" },
        {
          label: "Private Pool",
          key: "PrivatePool",
          chargeKey: "PrivatePoolCharges",
        },
        {
          label: "Heated Pool",
          key: "HeatedPool",
          chargeKey: "HeatedPoolCharges",
        },
        {
          label: "Infinity Pool",
          key: "InfinityPool",
          chargeKey: "InfinityPoolCharges",
        },
        {
          label: "Plunge Pool",
          key: "PlungePool",
          chargeKey: "PlungePoolCharges",
        },
        {
          label: "Pool with View",
          key: "PoolWithView",
          chargeKey: "PoolWithViewCharges",
        },
        {
          label: "Rooftop Pool",
          key: "RoofTopPool",
          chargeKey: "RoofTopPoolCharges",
        },
        {
          label: "Salt Water Pool",
          key: "SaltWaterPool",
          chargeKey: "SaltWaterPoolCharges",
        },
        {
          label: "Kids Pool",
          key: "KidsPool",
          chargeKey: "KidsPoolCharges",
        },
        { label: "Open All Year", key: "OpenAllYear" },
        { label: "All Ages Welcome", key: "AllAgesWelcome" },
        { label: "Indoor Pool with View", key: "IndoorPoolWithView" },
      ],
    },
    {
      title: "Reception Services",
      rows: [
        { label: "Invoice Provided", key: "InvoiceProvided" },
        { label: "Tour Desk", key: "TourDesk" },
        { label: "Lockers", key: "Lockers", chargeKey: "LockersCharges" },
        {
          label: "Luggage Storage",
          key: "LuggageStorage",
          chargeKey: "LuggageStorageCharges",
        },
      ],
    },
    {
      title: "Outdoor Features",
      rows: [
        { label: "Outdoor Furniture", key: "OutdoorFurniture" },
        { label: "Sun Terrace", key: "SunTerrace" },
      ],
    },
    {
      title: "Activities",
      rows: [
        {
          label: "Bicycle Rental",
          key: "BicycleRental",
          chargeKey: "BicycleRentalCharges",
        },
        {
          label: "Walking Tours",
          key: "WalkingTours",
          chargeKey: "WalkingToursCharges",
        },
        { label: "Darts", key: "Darts", chargeKey: "DartsCharges" },
        {
          label: "Indoor Play Area",
          key: "IndoorPlayArea",
          chargeKey: "IndoorPlayAreaCharges",
        },
        {
          label: "Board Games / Puzzles",
          key: "BoardGamesPuzzles",
          chargeKey: "BoardGamesPuzzlesCharges",
        },
        {
          label: "Evening Entertainment",
          key: "EveningEntertainment",
          chargeKey: "EveningEntertainmentCharges",
        },
        {
          label: "Live Music Performance",
          key: "LiveMusicPerformance",
          chargeKey: "LiveMusicPerformanceCharges",
        },
        {
          label: "Table Tennis",
          key: "TableTennis",
          chargeKey: "TableTennisCharges",
        },
        {
          label: "Billiards",
          key: "Billiards",
          chargeKey: "BilliardsCharges",
        },
        { label: "Bonfire", key: "Bonfire", chargeKey: "BonfireCharges" },
      ],
    },
    {
      title: "Food & Drinks",
      rows: [
        {
          label: "Snack Bar",
          key: "SnackBar",
          chargeKey: "SnackBarCharges",
        },
        { label: "Wine", key: "Wine", chargeKey: "WineCharges" },
        { label: "Fruits", key: "Fruits", chargeKey: "FruitsCharges" },
        { label: "Snacks", key: "Snacks", chargeKey: "SnacksCharges" },
      ],
    },
    {
      title: "Cleaning Services",
      rows: [
        { label: "Daily Housekeeping", key: "DailyHousekeeping" },
        {
          label: "Ironing Services",
          key: "IroningServices",
          chargeKey: "IroningServicesCharges",
        },
        { label: "Laundry", key: "Laundry", chargeKey: "LaundryCharges" },
      ],
    },
    {
      title: "Wellness",
      rows: [
        {
          label: "Yoga Classes",
          key: "YogaClasses",
          chargeKey: "YogaClassesCharges",
        },
        { label: "Fitness", key: "Fitness", chargeKey: "FitnessCharges" },
        {
          label: "Spa Facilities",
          key: "SpaFacilities",
          chargeKey: "SpaFacilitiesCharges",
        },
      ],
    },
    {
      title: "Business Facilities",
      rows: [
        {
          label: "Fax / Photocopying",
          key: "FaxPhotocopying",
          chargeKey: "FaxPhotocopyingCharges",
        },
        {
          label: "Business Center",
          key: "BusinessCenter",
          chargeKey: "BusinessCenterCharges",
        },
        {
          label: "Meeting / Banquet Rooms",
          key: "MeetingBanquetRooms",
          chargeKey: "MeetingBanquetRoomsCharges",
        },
      ],
    },
    {
      title: "Safety & Security",
      rows: [
        { label: "Fire Extinguisher", key: "FireExtinguisher" },
        { label: "CCTV Outside Property", key: "CctvOutsideProperty" },
        { label: "CCTV in Common Areas", key: "CctvinCommonAreas" },
        { label: "Smoke Alarm", key: "SmokeAlarm" },
        { label: "Security Alarm", key: "SecurityAlarm" },
        { label: "Key Card Access", key: "KeyCardAccess" },
        { label: "24-Hour Security", key: "TwentyFourSecurity" },
        { label: "Safety Deposit Box", key: "SafetyDepositBox" },
      ],
    },
    {
      title: "General",
      rows: [
        { label: "Shared Lounge/TV Area", key: "SharedLoungeTVArea" },
        { label: "Designated Smoking Area", key: "DesignatedSmokingArea" },
        { label: "Tile/Marble Floor", key: "TileMarbleFloor" },
        { label: "Soundproofing", key: "Soundproofing" },
        { label: "Fan", key: "Fan" },
        { label: "Family Rooms", key: "FamilyRooms" },
        { label: "Smoking allowed", key: "SmokingAllowed" },
        { label: "Smoking not allowed", key: "SmokingNotAllowed" },
      ],
    },
    {
      title: "Accessibility",
      rows: [
        { label: "Wheelchair Accessible", key: "WheelchairAccessible" },
        {
          label: "Upper Floors Accessible by Elevator",
          key: "UpperFloorsAccessiblebyElevator",
        },
      ],
    },
    {
      title: "Languages Spoken",
      rows: [
        { label: "Hindi", key: "Hindi" },
        { label: "English", key: "English" },
        { label: "Local Language", key: "LocalLanguage" },
      ],
    },
  ];

  return (
    <>
      <div className="facilities-section" style={{ marginTop: "20px" }}>
        <h3 style={{ marginBottom: "10px" }}>Facilities</h3>

        {facilitySections.map((section) =>
          renderAmenitySection(section.title, section.rows)
        )}

        <p style={{ marginTop: 10 }}>
          <strong>Additional Facilities Comments:</strong>{" "}
          {renderEditableValue("facilitiesComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}


      case "Room Type": {
  const roomTypes = isEditing
    ? getRoomTypeRows()
    : Array.isArray(property.roomTypes)
    ? property.roomTypes.filter(
        (rt) =>
          rt &&
          (rt.roomTypeName ||
            rt.name ||
            rt.roomSize ||
            rt.roomNumbers ||
            rt.baseAdult ||
            rt.baseChild ||
            rt.maxAdult ||
            rt.maxChild ||
            rt.maxOccupancy)
      )
    : [];

  return (
    <>
      <div className="placeholder-table">
        <h4
          style={{
            color: "#2e7d32",
            marginTop: "20px",
            textAlign: "left",
          }}
        >
          Room Type Details
        </h4>

        {roomTypes.length > 0 ? (
          roomTypes.map((room, index) => {
            const photos = getRoomPhotos(room);
            const selectedAmenities = getSelectedRoomAmenities(room);
            const availableAmenities = getAvailableRoomAmenities(room);

            return (
              <div key={room.id ?? index} className="room-type-card">
                <div className="room-type-header">
                  <h5>
                    Room Type {index + 1}:{" "}
                    <span>
                      {isEditing
                        ? room.roomTypeName || room.name || "New Room Type"
                        : room.roomTypeName || room.name || "—"}
                    </span>
                  </h5>

                  {isEditing && (
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => removeRoomTypeRow(index)}
                    >
                      Remove Room Type
                    </button>
                  )}
                </div>

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>Room Type Name</th>
                      <th>Bed Type</th>
                      <th>Room Size</th>
                      <th>Room Numbers</th>
                      <th>Beds Count Per Room</th>
                      <th>Base Adult</th>
                      <th>Base Child</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "roomTypeName")
                          : room.roomTypeName || room.name || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "bedType")
                          : room.bedType || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "roomSize")
                          : room.roomSize || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "roomNumbers")
                          : room.roomNumbers || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "bedsCountPerRoom")
                          : room.bedsCountPerRoom || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "baseAdult")
                          : room.baseAdult || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "baseChild")
                          : room.baseChild || "—"}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>Max Adult</th>
                      <th>Max Child</th>
                      <th>Max Occupancy</th>
                      <th>Room Inventory</th>
                      <th>Rate Threshold Min</th>
                      <th>Rate Threshold Max</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "maxAdult")
                          : room.maxAdult || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "maxChild")
                          : room.maxChild || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "maxOccupancy")
                          : room.maxOccupancy || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "roomInventory")
                          : room.roomInventory || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "rateThresholdMin")
                          : room.rateThresholdMin || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "rateThresholdMax")
                          : room.rateThresholdMax || "—"}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>Count of Extra mattress</th>
                      <th>Extra Adult Price</th>
                      <th>Extra Child Price</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "extraMattressCount")
                          : room.extraMattressCount || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "extraMattressPriceAdult")
                          : room.extraMattressPriceAdult || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "extraMattressPriceChild")
                          : room.extraMattressPriceChild || "—"}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>View from Room</th>
                      <th>Window openable</th>
                      <th>Private balcony</th>
                      <th>Number of washroom</th>
                      <th>AC Type</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "viewFromRoom")
                          : room.viewFromRoom || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "windowOpenable")
                          : room.windowOpenable || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "privateBalcony")
                          : room.privateBalcony || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "numberOfWashrooms")
                          : room.numberOfWashrooms || "—"}
                      </td>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "acType")
                          : room.acType || "—"}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>Breakfast Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {isEditing
                          ? renderRoomTypeInput(index, room, "breakfastType")
                          : room.breakfastType || "—"}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h6 className="room-subheading">Room Photographs</h6>

                <div className="room-photo-box">
                  {photos.length > 0 ? (
                    <div className="room-photo-grid">
                      {photos.map((photo, photoIndex) => {
                        const imgURL = buildRoomPhotoURL(photo);

                        return (
                          <div className="room-photo-item" key={photoIndex}>
                           <img
  key={imgURL}
  src={imgURL}
  alt={`Room ${photoIndex + 1}`}
  onError={(e) => {
    console.error("Room image failed:", imgURL);
  }}
/>

                            {isEditing && (
                              <button
                                type="button"
                                className="delete-doc-btn"
                                onClick={async () => {
                                  await removeRoomPhoto(index, photoIndex);
                                }}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p style={{ color: "#777" }}>No room photos uploaded.</p>
                  )}

                  {isEditing && photos.length < 4 && (
                    <div style={{ marginTop: "10px" }}>
                      <label className="upload-inline-label">
                        Add Room Photos
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                         onChange={async (e) => {
  const files = e.target.files;

  try {
    await uploadRoomPhotos(index, files);
    e.target.value = "";
    alert("Room photos uploaded successfully.");
  } catch (err) {
    console.error("Room photo upload failed:", err.response?.data || err);

    alert(
      err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Failed to upload room photos."
    );
  }
}}
                        />
                      </label>

                      <div style={{ fontSize: "12px", marginTop: "4px" }}>
                        Maximum 4 photos allowed. Remaining: {4 - photos.length}
                      </div>
                    </div>
                  )}
                </div>

                <h6 className="room-subheading">Amenities</h6>

                <div className="room-amenities-box">
                  {selectedAmenities.length > 0 ? (
                    <div className="room-amenity-list">
                      {selectedAmenities.map((amenity) => (
                        <div className="room-amenity-chip" key={amenity.key}>
                          <span>
                            {amenity.label}
                            {amenity.key === "Ac" && room.acType ? ` - ${room.acType}` : ""}
                          </span>

                          {isEditing && (
                            <button
                              type="button"
                              onClick={() =>
                                removeRoomAmenity(index, amenity.key)
                              }
                            >
                              −
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ color: "#777" }}>No amenities selected.</p>
                  )}

                  {isEditing && availableAmenities.length > 0 && (
  <div className="add-amenity-row">
    <select
      multiple
      className="edit-input amenity-multi-select"
      defaultValue={[]}
      onChange={(e) => {
        const selectedKeys = Array.from(
          e.target.selectedOptions,
          (option) => option.value
        );

        addRoomAmenities(index, selectedKeys);

        Array.from(e.target.options).forEach((option) => {
          option.selected = false;
        });
      }}
    >
      {availableAmenities.map((amenity) => (
        <option key={amenity.key} value={amenity.key}>
          {amenity.label}
        </option>
      ))}
    </select>

    <small style={{ display: "block", marginTop: "5px", color: "#666" }}>
      Use Click or Drag to select multiple amenities
    </small>
  </div>
)}
                </div>

                <div style={{ marginTop: "12px" }}>
                  <strong>Room Comments:</strong>{" "}
                  {isEditing ? (
                    <textarea
                      className="edit-input"
                      rows="2"
                      value={room.comments || room.roomTypeComments || ""}
                      onChange={(e) =>
                        handleRoomTypeFieldChange(
                          index,
                          "comments",
                          e.target.value
                        )
                      }
                    />
                  ) : (
                    room.comments || room.roomTypeComments || "—"
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ marginTop: 10, color: "#999" }}>
            No room types added.
          </p>
        )}

        {isEditing && (
          <button
            type="button"
            className="save-btn"
            style={{ marginTop: "12px" }}
            onClick={addRoomTypeRow}
          >
            + Add Room Type
          </button>
        )}

        <p style={{ marginTop: 16 }}>
          <strong>Overall Room Type Comments:</strong>{" "}
          {renderEditableValue("roomTypeComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}


      case "Rate Plan with Rates": {
  const ratePlansArray = isEditing
    ? getRatePlanRows()
    : Array.isArray(property.ratePlans)
    ? property.ratePlans.filter(
        (rp) =>
          rp &&
          ((rp.roomTypeName && rp.roomTypeName.trim() !== "") ||
            (rp.ratePlanName && rp.ratePlanName.trim() !== "") ||
            (rp.baseRates && rp.baseRates.toString().trim() !== ""))
      )
    : [];

  return (
    <>
      <div className="placeholder-table">
        <h4
          style={{
            color: "#2e7d32",
            marginTop: "20px",
            textAlign: "left",
          }}
        >
          Rate Plan with Rates & Meal Prices
        </h4>

        {ratePlansArray.length > 0 ? (
          ratePlansArray.map((rp, index) => {
            return (
              <div
                key={rp.id ?? index}
                style={{
                  marginBottom: "30px",
                  borderBottom: "1px solid #eee",
                  paddingBottom: "20px",
                }}
              >
                <h5
                  style={{
                    color: "#2e7d32",
                    marginBottom: "10px",
                  }}
                >
                  Rate Plan {index + 1}:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {isEditing
                      ? rp.ratePlanName || "New Rate Plan"
                      : rp.ratePlanName || "—"}
                  </span>
                </h5>

                <table
                  className="property-table"
                  style={{ marginBottom: "15px" }}
                >
                  <thead>
                    <tr>
                      <th>Room Type Name</th>
                      <th>Rate Plan Name</th>
                      <th>Base Rates</th>
                      <th>Extra Adult Rate</th>
                      <th>Extra Child Rate</th>
                      {isEditing && <th>Action</th>}
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        {isEditing
                          ? renderRatePlanInput(
                              index,
                              rp,
                              "roomTypeName",
                              "rate-room-type-options"
                            )
                          : rp.roomTypeName || "—"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "ratePlanName")
                          : rp.ratePlanName || "—"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "baseRates")
                          : rp.baseRates || "—"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "extraAdultRate")
                          : rp.extraAdultRate || "—"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "extraChildRate")
                          : rp.extraChildRate || "—"}
                      </td>

                      {isEditing && (
                        <td>
                          <button
                            type="button"
                            className="discard-btn"
                            onClick={() => removeRatePlanRow(index)}
                          >
                            Remove
                          </button>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>

                <h6
                  style={{
                    color: "#2e7d32",
                    marginBottom: "5px",
                    textAlign: "left",
                  }}
                >
                  Meal Plan Prices
                </h6>

                <table className="property-table">
                  <thead>
                    <tr>
                      <th>Plan</th>
                      <th>Breakfast Price</th>
                      <th>Lunch Price</th>
                      <th>Dinner Price</th>
                      <th>Meal Price Only</th>
                      <th>Total Rate Plan</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
  <td>EP</td>

  <td>-</td>
  <td>-</td>
  <td>-</td>

  <td>-</td>
  <td>{toNumber(rp.baseRates) || "-"}</td>
</tr>

                    <tr>
                      <td>CP</td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "cpBreakfast")
                          : rp.cpBreakfast || "-"}
                      </td>

                      <td>-</td>
                      <td>-</td>

                      <td>{calculateMealPriceOnly("CP", rp) || "-"}</td>
                      <td>{calculateTotalRatePlan("CP", rp) || "-"}</td>
                    </tr>

                    <tr>
                      <td>MAP</td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "mapBreakfast")
                          : rp.mapBreakfast || "-"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "mapLunch")
                          : rp.mapLunch || "-"}
                      </td>

                      <td>-</td>

                      <td>{calculateMealPriceOnly("MAP", rp) || "-"}</td>
                      <td>{calculateTotalRatePlan("MAP", rp) || "-"}</td>
                    </tr>

                    <tr>
                      <td>AP</td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "apBreakfast")
                          : rp.apBreakfast || "-"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "apLunch")
                          : rp.apLunch || "-"}
                      </td>

                      <td>
                        {isEditing
                          ? renderRatePlanInput(index, rp, "apDinner")
                          : rp.apDinner || "-"}
                      </td>

                      <td>{calculateMealPriceOnly("AP", rp) || "-"}</td>
                      <td>{calculateTotalRatePlan("AP", rp) || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          })
        ) : (
          <p style={{ marginTop: 10, color: "#999" }}>
            No rate plans available.
          </p>
        )}

        {isEditing && (
          <button
            type="button"
            className="save-btn"
            style={{ marginTop: "12px" }}
            onClick={addRatePlanRow}
          >
            + Add Rate Plan
          </button>
        )}

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {renderEditableValue("ratePlanComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}



      case "Policy Details": {
  return (
    <>
      <div className="placeholder-table">
        <h4
          style={{
            color: "#2e7d32",
            marginTop: "20px",
            textAlign: "left",
          }}
        >
          Policy Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>Policy Questions</th>
              <th>Answer</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>P1. Do you allow unmarried couples?</td>
              <td>
                {renderEditableValue(
                  "unmarriedCouples",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P2. Do you allow guests below 18 years of age?</td>
              <td>
                {renderEditableValue(
                  "guestBelow18",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P3. Groups with only male guests are allowed?</td>
              <td>
                {renderEditableValue(
                  "groupOnlyMale",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P4. Are private parties or events allowed?</td>
              <td>
                {renderEditableValue(
                  "privateParties",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>
                P5. Can guests invite outside visitors in the room during their
                stay?
              </td>
              <td>
                {renderEditableValue(
                  "guestInvite",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P6. Is your property accessible for wheelchair users?</td>
              <td>
                {renderEditableValue(
                  "accessibleForWheelchair",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P7. Are pets allowed?</td>
              <td>
                {renderEditableValue(
                  "petsAllowed",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>Pet Charges</td>
              <td>{renderEditableValue("petsAllowedCharges", "Free")}</td>
            </tr>

            <tr>
              <td>P8. Do you have a 24-hour check-in?</td>
              <td>
                {renderEditableValue(
                  "twentyfourCheckin",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P9. Child Age Policy</td>
              <td>{renderEditableValue("childAgePolicy")}</td>
            </tr>

            <tr>
              <td>Child Age (up to, in years)</td>
              <td>{renderEditableValue("childAgePolicyYears", "—")}</td>
            </tr>

            <tr>
              <td>P10. Extra Bed Policy</td>
              <td>{renderEditableValue("extraBedPolicy")}</td>
            </tr>

            <tr>
              <td>P11. Booking cancellation before check-in</td>
              <td>
                {renderEditableValue(
                  "bookingCancellationBefore",
                  "—",
                  "cancellation-day-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P12. Non veg allowed?</td>
              <td>
                {renderEditableValue(
                  "nonVegAllowed",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P13. Outside food delivery allowed?</td>
              <td>
                {renderEditableValue(
                  "outsideFoodDeliveryAllowed",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P14. Alcohol consumption allowed?</td>
              <td>
                {renderEditableValue(
                  "alcoholAllowed",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>

            <tr>
              <td>P15. First aid kit provided?</td>
              <td>
                {renderEditableValue(
                  "firstAidKitProvided",
                  "—",
                  "yes-no-options"
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 10 }}>
          <strong>Additional Policy Comments:</strong>{" "}
          {renderEditableValue("policyComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}

case "Payment Methods": {
  const paymentDocs = [
    { label: "Cancelled Cheque", key: "cancelledCheque" },
    { label: "Payment QR", key: "paymentQr" },
  ];

  return (
    <>
      <div className="placeholder-table">
        <h4
          style={{
            color: "#2e7d32",
            marginTop: "20px",
            textAlign: "left",
          }}
        >
          Payment Methods
        </h4>

        {/* Bank details */}
        <table className="property-table">
          <thead>
            <tr>
              <th>Payment Method</th>
              <th>Account No.</th>
              <th>Account Holder Name</th>
              <th>IFSC Code</th>
              <th>Branch Name</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{renderEditableValue("paymentMethods")}</td>
              <td>{renderEditableValue("accountNumber")}</td>
              <td>{renderEditableValue("accountHolderName")}</td>
              <td>{renderEditableValue("ifsc")}</td>
              <td>{renderEditableValue("branchName")}</td>
            </tr>
          </tbody>
        </table>

        {/* Payment documents */}
        <table className="property-table" style={{ marginTop: "20px" }}>
          <thead>
            <tr>
              <th>Document</th>
              <th>Preview / File</th>
              <th>Uploaded?</th>
              <th>Download</th>
              {isEditing && <th>Upload / Re-upload</th>}
            </tr>
          </thead>

          <tbody>
            {paymentDocs.map((doc, i) => {
              const docStatus = property.documentStatus?.[doc.key];
const storedValue = docStatus?.hasFile ? docStatus.fileName : "";
const fileURL = docStatus?.hasFile
  ? buildDocumentURL(doc.key, storedValue)
  : null;

              const isPdf =
                typeof storedValue === "string" &&
                storedValue.toLowerCase().endsWith(".pdf");

              return (
                <tr key={i}>
                  <td>{doc.label}</td>

                  {/* Preview */}
                  <td>
                    {fileURL ? (
                      isPdf ? (
                        <a
                          href={fileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#007bff",
                            textDecoration: "underline",
                          }}
                        >
                          View PDF
                        </a>
                      ) : (
                        <img
  src={fileURL}
  alt={doc.label}
  onError={(e) => {
    console.error("Document preview failed:", fileURL);
    e.currentTarget.style.display = "none";
  }}
  style={{
    width: "80px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "6px",
  }}
/>
                      )
                    ) : (
                      <span style={{ color: "red" }}>—</span>
                    )}
                  </td>

                  {/* Status */}
                  <td
                    style={{
                      fontWeight: 500,
                      color: storedValue ? "green" : "red",
                    }}
                  >
                    {storedValue ? "Yes" : "No"}
                  </td>

                  {/* Download */}
                  <td>
                    {fileURL ? (
                      <a
  href={fileURL}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "13px",
    fontWeight: "500",
  }}
>
  View / Download
</a>
                    ) : (
                      "—"
                    )}
                  </td>

                  {/* Upload / Re-upload / Delete */}
{isEditing && (
  <td>
    <div className="payment-doc-actions">
      <label className="upload-inline-label">
        {storedValue ? "Re-upload" : "Upload"}
        <input
          type="file"
          accept="image/*,.pdf"
          onChange={(e) =>
            setDocUploads((prev) => ({
              ...prev,
              [doc.key]: e.target.files[0],
            }))
          }
        />
      </label>

      {storedValue && (
        <button
          type="button"
          className="delete-doc-btn"
          onClick={() => handleDocumentDelete(doc.key)}
          disabled={uploadingDocs}
        >
          Delete
        </button>
      )}
    </div>

    {docUploads[doc.key] && (
      <div style={{ fontSize: "12px", marginTop: "5px" }}>
        Selected: {docUploads[doc.key].name}
      </div>
    )}
  </td>
)}
                </tr>
              );
            })}
          </tbody>
        </table>

        {isEditing && (
          <button
            type="button"
            className="save-btn"
            style={{ marginTop: "12px" }}
            onClick={handleDocUpload}
            disabled={uploadingDocs}
          >
            {uploadingDocs ? "Uploading..." : "Upload Selected Documents"}
          </button>
        )}

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {renderEditableValue("paymentMethodComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}




    case "OTA Information": {
  const rows = isEditing
    ? getOtaInfoRows()
    : Array.isArray(property.otaInfo)
    ? property.otaInfo.filter(
        (row) =>
          row &&
          ((row.otaName && row.otaName.trim() !== "") ||
            (row.propertyCode && row.propertyCode.trim() !== "") ||
            (row.otaUserName && row.otaUserName.trim() !== "") ||
            (row.otaPassword && row.otaPassword.trim() !== ""))
      )
    : [];

  return (
    <>
      <div className="placeholder-table">
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          OTA / Channel Information
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>OTA / Channel Name</th>
              <th>Property Code</th>
              <th>Username</th>
              <th>Password</th>
              {isEditing && <th>Action</th>}
            </tr>
          </thead>

          <tbody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <tr key={row.id ?? idx}>
                  <td>{idx + 1}</td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        list="ota-channel-options"
                        value={row.otaName || ""}
                        onChange={(e) =>
                          handleOtaInfoChange(idx, "otaName", e.target.value)
                        }
                      />
                    ) : (
                      row.otaName || "—"
                    )}
                  </td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        value={row.propertyCode || ""}
                        onChange={(e) =>
                          handleOtaInfoChange(
                            idx,
                            "propertyCode",
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      row.propertyCode || "—"
                    )}
                  </td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        value={row.otaUserName || ""}
                        onChange={(e) =>
                          handleOtaInfoChange(
                            idx,
                            "otaUserName",
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      row.otaUserName || "—"
                    )}
                  </td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        value={row.otaPassword || ""}
                        onChange={(e) =>
                          handleOtaInfoChange(
                            idx,
                            "otaPassword",
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      row.otaPassword || "—"
                    )}
                  </td>

                  {isEditing && (
                    <td>
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => removeOtaInfoRow(idx)}
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={isEditing ? "6" : "5"}
                  style={{ textAlign: "center", color: "gray" }}
                >
                  No OTA / Channel information added.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {isEditing && (
          <button
            type="button"
            className="save-btn"
            style={{ marginTop: "12px" }}
            onClick={addOtaInfoRow}
          >
            + Add OTA Information
          </button>
        )}

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {renderEditableValue("otaInfoComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}

       case "Credentials":
  return (
    <>
      <div className="placeholder-table">
        {/* Instagram */}
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Instagram Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>Exists?</th>
              <th>Username</th>
              <th>Password</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {renderEditableValue(
                  "instaExists",
                  "—",
                  "credential-status-options"
                )}
              </td>
              <td>{renderEditableValue("instaUsername")}</td>
              <td>{renderEditableValue("instaPassword")}</td>
            </tr>
          </tbody>
        </table>

        {/* Facebook */}
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Facebook Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>Exists?</th>
              <th>Page / Username</th>
              <th>Password</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {renderEditableValue(
                  "facebookExists",
                  "—",
                  "credential-status-options"
                )}
              </td>
              <td>{renderEditableValue("facebookUsername")}</td>
              <td>{renderEditableValue("facebookPassword")}</td>
            </tr>
          </tbody>
        </table>

        {/* Google Business */}
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Google Business Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>Profile Exists?</th>
              <th>Google Profile</th>
              <th>Primary ID</th>
              <th>Mobile Number Present on Page?</th>
              <th>Mobile Number for Updation</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {renderEditableValue(
                  "googleProfileExists",
                  "—",
                  "credential-status-options"
                )}
              </td>
              <td>{renderEditableValue("googleProfile")}</td>
              <td>{renderEditableValue("primaryID")}</td>
              <td>
                {renderEditableValue(
                  "mobileNumberPresent",
                  "—",
                  "credential-google-options"
                )}
              </td>
              <td>{renderEditableValue("mobileNumberForUpdation")}</td>
            </tr>
          </tbody>
        </table>

        {/* Tripadvisor */}
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Tripadvisor Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>Listing Exists?</th>
              <th>Phone Number</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {renderEditableValue(
                  "listingExists",
                  "—",
                  "credential-status-options"
                )}
              </td>
              <td>{renderEditableValue("phoneNumberTripadvisor")}</td>
            </tr>
          </tbody>
        </table>

        {/* Website */}
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Website Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>Website Exists?</th>
              <th>Domain</th>
              <th>Website Link</th>
              <th>Website ID</th>
              <th>Website Password</th>
              <th>Webmail ID</th>
              <th>Webmail Password</th>
              <th>Hotel ID</th>
              <th>Hotel ID Password</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {renderEditableValue(
                  "websiteExists",
                  "—",
                  "credential-status-options"
                )}
              </td>
              <td>{renderEditableValue("websiteDomain")}</td>
              <td>{renderEditableValue("websiteLink")}</td>
              <td>{renderEditableValue("websiteID")}</td>
              <td>{renderEditableValue("websitePassword")}</td>
              <td>{renderEditableValue("webmailID")}</td>
              <td>{renderEditableValue("webmailPassword")}</td>
              <td>{renderEditableValue("hotelID")}</td>
              <td>{renderEditableValue("hotelIDPassword")}</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {isEditing
            ? renderEditableValue("credentialComments")
            : property.credentialComments || "—"}
        </p>
      </div>

      {renderEditActions()}
    </>
  );

      case "Extra Charges": {
  const rows = isEditing
    ? getExtraChargesRows()
    : Array.isArray(property.extraCharges)
    ? property.extraCharges.filter(
        (row) =>
          row &&
          ((row.extraChargeName && row.extraChargeName.trim() !== "") ||
            (row.extraChargePrice && row.extraChargePrice.trim() !== "") ||
            (row.extraPercentageCharged &&
              row.extraPercentageCharged.trim() !== ""))
      )
    : [];

  return (
    <>
      <div className="placeholder-table">
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Extra Charges Details
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Charge Name</th>
              <th>Price</th>
              <th>% Charged</th>
              {isEditing && <th>Action</th>}
            </tr>
          </thead>

          <tbody>
            {rows.length > 0 ? (
              rows.map((row, idx) => (
                <tr key={row.id ?? idx}>
                  <td>{idx + 1}</td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        list="extra-charge-name-options"
                        value={row.extraChargeName || ""}
                        onChange={(e) =>
                          handleExtraChargeChange(
                            idx,
                            "extraChargeName",
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      row.extraChargeName || "—"
                    )}
                  </td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={row.extraChargePrice || ""}
                        placeholder="Enter price"
                        onChange={(e) =>
                          handleExtraChargeChange(
                            idx,
                            "extraChargePrice",
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      row.extraChargePrice || "—"
                    )}
                  </td>

                  <td>
                    {isEditing ? (
                      <input
                        className="edit-input"
                        type="text"
                        list="extra-charge-gst-options"
                        value={row.extraPercentageCharged || ""}
                        onChange={(e) =>
                          handleExtraChargeChange(
                            idx,
                            "extraPercentageCharged",
                            e.target.value
                          )
                        }
                      />
                    ) : (
                      row.extraPercentageCharged || "—"
                    )}
                  </td>

                  {isEditing && (
                    <td>
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => removeExtraChargeRow(idx)}
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={isEditing ? "5" : "4"}
                  style={{ textAlign: "center", color: "gray" }}
                >
                  No extra charges added.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {isEditing && (
          <button
            type="button"
            className="save-btn"
            style={{ marginTop: "12px" }}
            onClick={addExtraChargeRow}
          >
            + Add Extra Charge
          </button>
        )}

        <p style={{ marginTop: 10 }}>
          <strong>Comments:</strong>{" "}
          {renderEditableValue("extraChargesComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
}



        case "FAQ":
  return (
    <>
      <div className="placeholder-table">
        <h4 style={{ color: "#2e7d32", marginTop: "20px", textAlign: "left" }}>
          Frequently Asked Questions
        </h4>

        <table className="property-table">
          <thead>
            <tr>
              <th>FAQ</th>
              <th>Answer</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Q1. How many room categories are there?</td>
              <td>{renderEditableValue("howManyRoomCategories")}</td>
            </tr>

            <tr>
              <td>Q2. Total Room Inventory available at the property?</td>
              <td>{renderEditableValue("totalRoomInventories")}</td>
            </tr>

            <tr>
              <td>Q3. Unique Selling Factor?</td>
              <td>{renderEditableValue("uniqueSellingPoint")}</td>
            </tr>

            <tr>
              <td>
                Q4. Nearby popular locations with their exact distance from property?
              </td>
              <td>{renderEditableValue("nearbyPopularLocations")}</td>
            </tr>

            <tr>
              <td>Q5. Live Location / Special Directions</td>
              <td>{renderEditableValue("liveLocation")}</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 10 }}>
          <strong>Additional FAQ Comments:</strong>{" "}
          {renderEditableValue("faqComments")}
        </p>
      </div>

      {renderEditActions()}
    </>
  );
      default:
        return (
          <div className="placeholder-table">
            <p>No data available for {activeTab}.</p>
          </div>
        );
    }
  };

  return (
    <div className="property-details-container">
      <div className="details-header">
        <h2>Hotel Information</h2>
        <div className="header-actions">
       <button className="back-btn" onClick={() => navigate("/PropertiesList")}>
  ← Back to List
</button>
        {/* EDIT BUTTON START */}
       {canEditProperty && (
  <button
    className="edit-btn"
    onClick={handleEditClick}
    disabled={isEditing}
  >
    ✎ Edit
  </button>
)}
        {/* ENDS */}
      </div>
    </div>

      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>    
        ))}
      </div>

      <div className="table-wrapper">{renderTable()}</div>
{/* AUTO DATA LIST STARTS HERE MAY 15 2026 */}
      <datalist id="property-type-options">
  <option value="Apartment" />
  <option value="Boutique Hotel" />
  <option value="Cottage" />
  <option value="Guest House" />
  <option value="Homestay" />
  <option value="Hostel" />
  <option value="Hotel" />
  <option value="Motel" />
  <option value="Office" />
  <option value="Resort" />
  <option value="Restaurant" />
</datalist>

<datalist id="state-options">
  <option value="Andhra Pradesh" />
  <option value="Assam" />
  <option value="Bihar" />
  <option value="Chhattisgarh" />
  <option value="Delhi" />
  <option value="Goa" />
  <option value="Gujarat" />
  <option value="Haryana" />
  <option value="Himachal Pradesh" />
  <option value="Jharkhand" />
  <option value="Karnataka" />
  <option value="Kerala" />
  <option value="Madhya Pradesh" />
  <option value="Maharashtra" />
  <option value="Odisha" />
  <option value="Punjab" />
  <option value="Rajasthan" />
  <option value="Sikkim" />
  <option value="Tamil Nadu" />
  <option value="Telangana" />
  <option value="Uttar Pradesh" />
  <option value="Uttarakhand" />
  <option value="West Bengal" />
</datalist>

<datalist id="city-options">
  <option value="Agra" />
  <option value="Ahmedabad" />
  <option value="Aizawl" />
  <option value="Ajmer" />
  <option value="Alappuzha" />
  <option value="Aligarh" />
  <option value="Allahabad (Prayagraj)" />
  <option value="Amritsar" />
  <option value="Aurangabad" />
  <option value="Ayodhya" />
  <option value="Bangalore" />
  <option value="Bareilly" />
  <option value="Belgaum" />
  <option value="Bhopal" />
  <option value="Bhubaneswar" />
  <option value="Bilaspur" />
  <option value="Bokaro" />
  <option value="Calicut" />
  <option value="Chandigarh" />
  <option value="Chennai" />
  <option value="Coimbatore" />
  <option value="Cuttack" />
  <option value="Dalhousie" />
  <option value="Darjeeling" />
  <option value="Dehradun" />
  <option value="Delhi" />
  <option value="Dhanbad" />
  <option value="Dharamshala" />
  <option value="Dibrugarh" />
  <option value="Durgapur" />
  <option value="Dwarka" />
  <option value="Ernakulam" />
  <option value="Faridabad" />
  <option value="Gandhinagar" />
  <option value="Gangtok" />
  <option value="Gaya" />
  <option value="Ghaziabad" />
  <option value="Goa" />
  <option value="Gorakhpur" />
  <option value="Guntur" />
  <option value="Gurugram" />
  <option value="Guwahati" />
  <option value="Gwalior" />
  <option value="Haridwar" />
  <option value="Hisar" />
  <option value="Hubli" />
  <option value="Hyderabad" />
  <option value="Imphal" />
  <option value="Indore" />
  <option value="Itanagar" />
  <option value="Jabalpur" />
  <option value="Jaipur" />
  <option value="Jaisalmer" />
  <option value="Jalandhar" />
  <option value="Jammu" />
  <option value="Jamshedpur" />
  <option value="Jodhpur" />
  <option value="Junagadh" />
  <option value="Kanpur" />
  <option value="Kanyakumari" />
  <option value="Kochi" />
  <option value="Kodaikanal" />
  <option value="Kolkata" />
  <option value="Kollam" />
  <option value="Kollur" />
  <option value="Kota" />
  <option value="Kozhikode" />
  <option value="Kullu" />
  <option value="Lucknow" />
  <option value="Ludhiana" />
  <option value="Madurai" />
  <option value="Manali" />
  <option value="Mangalore" />
  <option value="Manipur" />
  <option value="Mathura" />
  <option value="Meerut" />
  <option value="Mumbai" />
  <option value="Mussoorie" />
  <option value="Mysuru" />
  <option value="Nagpur" />
  <option value="Nainital" />
  <option value="Nashik" />
  <option value="Noida" />
  <option value="Ooty" />
  <option value="Palakkad" />
  <option value="Panipat" />
  <option value="Panjim" />
  <option value="Patna" />
  <option value="Pondicherry" />
  <option value="Prayagraj" />
  <option value="Pune" />
  <option value="Pushkar" />
  <option value="Raipur" />
  <option value="Rajkot" />
  <option value="Ramnagar" />
  <option value="Ranchi" />
  <option value="Rishikesh" />
  <option value="Roorkee" />
  <option value="Salem" />
  <option value="Shimla" />
  <option value="Siliguri" />
  <option value="Solapur" />
  <option value="Srinagar" />
  <option value="Surat" />
  <option value="Thane" />
  <option value="Thiruvananthapuram" />
  <option value="Tiruchirappalli" />
  <option value="Tirupati" />
  <option value="Tirunelveli" />
  <option value="Udaipur" />
  <option value="Vadodara" />
  <option value="Varanasi" />
  <option value="Vijayawada" />
  <option value="Visakhapatnam" />
  <option value="Vrindavan" />
  <option value="Warangal" />
</datalist>

<datalist id="invoice-reset-options">
  <option value="Yearly" />
  <option value="Monthly" />
  <option value="Never" />
</datalist>

<datalist id="rates-tax-options">
  <option value="Exclusive Taxes" />
  <option value="Inclusive Taxes" />
</datalist>

<datalist id="star-category-options">
  <option value="1 Star" />
  <option value="2 Star" />
  <option value="3 Star" />
  <option value="4 Star" />
  <option value="5 Star" />
  <option value="6 Star" />
  <option value="7 Star" />
</datalist>

<datalist id="yes-no-options">
  <option value="Yes" />
  <option value="No" />
</datalist>

<datalist id="time-options">
  <option value="10:00 AM" />
  <option value="11:00 AM" />
  <option value="12:00 PM" />
  <option value="01:00 PM" />
  <option value="02:00 PM" />
</datalist>

<datalist id="floor-options">
  <option value="1" />
  <option value="2" />
  <option value="3" />
  <option value="4" />
  <option value="5" />
  <option value="6" />
  <option value="7" />
</datalist>
      {/*  CONTACT DETAILS STARTS HERE */}
      <datalist id="owner-designation-options">
  <option value="Owner" />
  <option value="Owner (Lease Property)" />
  <option value="Partner" />
  <option value="Brother of Owner" />
  <option value="Sister of Owner" />
  <option value="Manager" />
  <option value="General Manager" />
  <option value="Director" />
  <option value="Other" />
</datalist>

<datalist id="manager-designation-options">
  <option value="Front Office Manager" />
  <option value="General Manager" />
  <option value="Manager" />
  <option value="Managing Director" />
  <option value="Operations Manager" />
  <option value="Reservation Executive" />
</datalist>

      {/* CREDENTIALS DATALIST START HERE */}
      <datalist id="credential-status-options">
  <option value="Yes" />
  <option value="Yes, but no access" />
  <option value="Need to create" />
</datalist>

      <datalist id="credential-google-options">
  <option value="Yes" />
  <option value="No" />
</datalist>

      {/* POLICY DETAILS DATALIST */}
      <datalist id="cancellation-day-options">
  <option value="Day 1" />
  <option value="Day 2" />
  <option value="Day 3" />
  <option value="Day 4" />
  <option value="Day 5" />
  <option value="Day 6" />
  <option value="Day 7" />
</datalist>

      {/* EXTRA CHARGES STARTS HERE */}
      <datalist id="extra-charge-name-options">
  <option value="No Extra Charges" />
  <option value="Car Wash" />
  <option value="Extra Bed/Mattress" />
  <option value="Heater Service" />
  <option value="Liquor Service" />
  <option value="Shuttle Service" />
  <option value="Spa Service" />
  <option value="Tour Guide" />
</datalist>

<datalist id="extra-charge-gst-options">
  <option value="N/A" />
  <option value="5% GST" />
  <option value="12% GST" />
  <option value="18% GST" />
</datalist>
      {/* ENDS */}

      {/* OTA INFORMATION DATALIST STARTS HERE */}
<datalist id="ota-channel-options">
  <option value="MMT" />
  <option value="Agoda" />
  <option value="Booking" />
  <option value="Cleartrip" />
  <option value="Easemytrip" />
  <option value="Expedia" />
  <option value="Goibibo" />
  <option value="Not Listed" />
</datalist>
{/* OTA INFORMATION DATALIST ENDS HERE */}

      {/* RATE PLAN DATALIST STARTS HERE */}
<datalist id="rate-room-type-options">
  <option value="Standard Room" />
  <option value="Deluxe Room" />
  <option value="Super Deluxe Room" />
  <option value="Superior Room" />
  <option value="Premium Room" />
  <option value="Executive Room" />
  <option value="Classic Room" />
  <option value="Luxury Room" />
  <option value="Economy Room" />
  <option value="Club Room" />
  <option value="Studio Room" />
  <option value="Single Room" />
  <option value="Double Room" />
  <option value="Twin Room" />
  <option value="Triple Room" />
  <option value="Quadruple Room" />
  <option value="Queen Room" />
  <option value="King Room" />
  <option value="Family Room" />
  <option value="Junior Suite" />
  <option value="Executive Suite" />
  <option value="Deluxe Suite" />
  <option value="Family Suite" />
  <option value="Presidential Suite" />
  <option value="Honeymoon Suite" />
  <option value="Royal Suite" />
  <option value="Penthouse Suite" />
  <option value="Mountain View Room" />
  <option value="Sea View Room" />
  <option value="Lake View Room" />
  <option value="Garden View Room" />
  <option value="City View Room" />
  <option value="Pool View Room" />
  <option value="Valley View Room" />
  <option value="River View Room" />
  <option value="Forest View Room" />
  <option value="Balcony Room" />
  <option value="Terrace Room" />
  <option value="Private Pool Room" />
  <option value="Jacuzzi Room" />
  <option value="Cottage" />
  <option value="Luxury Cottage" />
  <option value="Premium Cottage" />
  <option value="Family Cottage" />
  <option value="Villa" />
  <option value="Luxury Villa" />
  <option value="Pool Villa" />
  <option value="Garden Villa" />
  <option value="Beach Villa" />
  <option value="Family Villa" />
  <option value="Bungalow" />
  <option value="Duplex Room" />
  <option value="Loft Room" />
  <option value="Cabin Room" />
  <option value="Tree House Room" />
  <option value="Studio Apartment" />
  <option value="One Bedroom Apartment" />
  <option value="Two Bedroom Apartment" />
  <option value="Three Bedroom Apartment" />
  <option value="Entire Apartment" />
  <option value="Chalet" />
  <option value="Mixed Dormitory Room" />
  <option value="Female Dormitory Room" />
  <option value="Male Dormitory Room" />
  <option value="Private Dorm Room" />
  <option value="Accessible Room" />
  <option value="Wheelchair Accessible Room" />
  <option value="Deluxe Double Room with Balcony" />
  <option value="Superior King Room with Mountain View" />
  <option value="Family Suite with Breakfast" />
  <option value="Executive Room with Free Cancellation" />
  <option value="Premium Cottage with Garden View" />
  <option value="Luxury Tent" />
  <option value="Glamping Tent" />
  <option value="Safari Tent" />
  <option value="Oceanfront Suite" />
  <option value="Poolside Room" />
  <option value="Courtyard Room" />
  <option value="Heritage Room" />
  <option value="Signature Suite" />
  <option value="Premier Room" />
  <option value="Skyline Suite" />
  <option value="Business Room" />
  <option value="Corporate Suite" />
  <option value="Romantic Suite" />
  <option value="Couple Suite" />
  <option value="Kids Theme Room" />
  <option value="Adventure Room" />
  <option value="Eco Room" />
  <option value="Minimal Room" />
  <option value="Premium King Suite" />
  <option value="Deluxe Twin Room" />
  <option value="Luxury Family Suite" />
  <option value="Club King Room" />
  <option value="Superior Twin Room" />
  <option value="Semi Deluxe Room" />
  <option value="Maharaja Suite" />
  <option value="Maharani Suite" />
  <option value="Royal Cottage" />
  <option value="Imperial Suite" />
  <option value="Lake Facing Cottage" />
  <option value="Hill View Cottage" />
  <option value="River Facing Room" />
  <option value="Sunrise View Room" />
  <option value="Sunset View Room" />
  <option value="Private Cabin" />
  <option value="Wooden Cottage" />
  <option value="Mud House" />
  <option value="Eco Cottage" />
  <option value="Tent Stay" />
  <option value="Dorm Bed" />
  <option value="Capsule Room" />
  <option value="Premium Chalet" />
  <option value="Luxury Chalet" />
  <option value="Family Chalet" />
  <option value="Duplex Villa" />
  <option value="Private Garden Villa" />
  <option value="Luxury Pool Suite" />
  <option value="Executive King Room" />
  <option value="Executive Twin Room" />
  <option value="Club Suite" />
  <option value="Panoramic View Suite" />
  <option value="Family Connecting Room" />
  <option value="Interconnected Room" />
  <option value="Shared Room" />
  <option value="Budget Room" />
  <option value="Compact Room" />
  <option value="Smart Room" />
  <option value="Comfort Room" />
  <option value="Heritage Suite" />
  <option value="Boutique Room" />
  <option value="Designer Room" />
  <option value="Artist Suite" />
</datalist>
{/* RATE PLAN DATALIST ENDS HERE */}
      
      {/* ENDS HERE */}
      <div className="copyright_footer">
        © 2026 DEVELOPED BY <span className="brand">Vaibhav Prajapati</span> at <span style={{color:'green'}}>RevX Hospitality</span>
      </div>
    </div>
  );
};

export default PropertyDetails;
